<template>
  <section>
    <sticky
      ref="sticky"
      @stickinessChanged="handleSticky"
    >
      <header>
        <slot name="header" />
      </header>
    </sticky>

    <main :style="{ 'padding-top': mainPaddingTop }">
      <slot />
    </main>
  </section>
</template>

<script>
import Sticky from '../../components/Sticky.vue'

export default {
  name: 'StickyHeaderLayout',
  components: {
    Sticky,
  },
  props: {
    zIndex: {
      type: Number,
      default: 1010,
    },
  },
  data() {
    return {
      mainPaddingTop: undefined,
      isSticky: false,
    }
  },
  methods: {
    handleSticky({ isSticky, height = 0 }) {
      this.isSticky = isSticky
      this.updatePaddingTop(isSticky, height)
      this.$emit('stickinessChanged', isSticky)
    },
    updatePaddingTop(isSticky, height = 0) {
      this.$nextTick(() => {
        if (isSticky) {
          this.mainPaddingTop = height
        } else {
          this.mainPaddingTop = 0
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  header {
    display: flex;
    flex-flow: column;
    background-color: white;
    padding: 8px 20px;
  }
  main {
    margin: auto 20px;
    min-height: 100vh;
  }
}
</style>

